import type { IAdHubState } from './types';
import { types } from './types';

export const initialState: IAdHubState = {
    connections: null,
    fetchingConnections: false,
    connecting: false,
    disconnecting: false,
    error: null,
};

export function adhubReducer(state = initialState, action: any): IAdHubState {
    switch (action.type) {
        case types.FETCH_CONNECTIONS:
            return { ...state, fetchingConnections: true, error: null };
        case types.FETCH_CONNECTIONS_SUCCESS:
            return { ...state, fetchingConnections: false, connections: action.payload };
        case types.FETCH_CONNECTIONS_FAIL:
            return { ...state, fetchingConnections: false, error: action.payload };

        case types.FETCH_META_OAUTH_URL:
        case types.EXCHANGE_META_OAUTH:
            return { ...state, connecting: true, error: null };
        case types.FETCH_META_OAUTH_URL_SUCCESS:
        case types.EXCHANGE_META_OAUTH_SUCCESS:
            return { ...state, connecting: false };
        case types.FETCH_META_OAUTH_URL_FAIL:
        case types.EXCHANGE_META_OAUTH_FAIL:
            return { ...state, connecting: false, error: action.payload };

        case types.DISCONNECT_PLATFORM:
            return { ...state, disconnecting: true, error: null };
        case types.DISCONNECT_PLATFORM_SUCCESS:
            return { ...state, disconnecting: false };
        case types.DISCONNECT_PLATFORM_FAIL:
            return { ...state, disconnecting: false, error: action.payload };

        default:
            return state;
    }
}
